var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showText || !_vm.edit
    ? _c(
        "div",
        {
          staticStyle: { width: "100%", height: "100%" },
          on: { click: _vm.onTextClick }
        },
        [
          _c(
            "span",
            { staticStyle: { display: "inline-block", width: "100%" } },
            [
              _vm._v(
                _vm._s(
                  _vm.attrs.complexTextConverter
                    ? _vm.attrs.complexTextConverter(_vm.rowData, _vm.value)
                    : _vm.value
                )
              )
            ]
          )
        ]
      )
    : _c(
        "div",
        { staticStyle: { margin: "0px", padding: "0px" } },
        [
          _c("el-input", {
            ref: "elInput",
            attrs: { value: String(_vm.value), maxlength: _vm.attrs.maxLength },
            on: {
              blur: _vm.onBlur,
              focus: _vm.onFocus,
              change: _vm.onChange,
              input: _vm.onInput
            }
          })
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }